import { render } from "react-dom";
import { FirebaseAppProvider } from "reactfire";

import App from "./App";

const firebaseConfig = {
  apiKey: "AIzaSyBg3u1sJlyJwQCE95oSDH_mtLABS-is8ZM",
  authDomain: "rxfire-525a3.firebaseapp.com",
  databaseURL: "https://rxfire-525a3.firebaseio.com",
  projectId: "rxfire-525a3",
  storageBucket: "rxfire-525a3.appspot.com",
  messagingSenderId: "844180061847",
  appId: "1:844180061847:web:400f7142e2d1aaeb"
};

const rootElement = document.getElementById("root");
render(
  <FirebaseAppProvider firebaseConfig={firebaseConfig}>
    <App />
  </FirebaseAppProvider>,
  rootElement
);
